module.exports = __webpack_public_path__ + "f19e27e7ad8130b0a0153710c53a83ad.pdf";